import type { SVGProps } from 'react';

const SvgAutomations = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M1.75 16.12a5.83 5.83 0 0 0 7.61 5.54 11.32 11.32 0 0 0 9 4.48h.25a5.78 5.78 0 1 0 .1-1.5h-.35A9.82 9.82 0 0 1 10.74 21a5.81 5.81 0 0 0-.31-9.95 9.83 9.83 0 0 1 7.67-3.69h.35a5.86 5.86 0 1 0-.1-1.5h-.25A11.31 11.31 0 0 0 9 10.48a6 6 0 0 0-1.41-.18 5.83 5.83 0 0 0-5.84 5.82m22.68 5.37a4.33 4.33 0 1 1-4.33 4.33 4.33 4.33 0 0 1 4.33-4.33m-.27-19.63a4.33 4.33 0 1 1-4.33 4.32 4.33 4.33 0 0 1 4.33-4.32M7.57 11.8a4.32 4.32 0 1 1-4.32 4.32 4.33 4.33 0 0 1 4.32-4.32"
      data-name="automation"
    />
  </svg>
);

export default SvgAutomations;
